module.exports = __webpack_public_path__ + "static/media/s_bar6.f47a8de8.svg";